import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function ECRIcon(props) {
  return (
    <SvgIcon viewBox='0 0 75 75' {...props} >
      <defs>
        <style>{".cls-1{fill:url(#OrangeGradient);}.cls-2{fill:#000;}"}</style>
        <linearGradient id="OrangeGradient" x1="31.22" y1="-154.4" x2="181.22" y2="-154.4" gradientTransform="translate(71.57 221.78) rotate(-45)" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#c8511b"/>
          <stop offset="1" stopColor="#f90"/>
        </linearGradient>
      </defs>
      <g id="Reference">
        <g id="Icon_Test" data-name="Icon Test">
          <path className="cls-2" 
            d="M59.5,30.06V50.51l-18,10.4V53.15l10-5.77a2,2,0,0,0,1-1.46,5,5,0,0,0,0-.78V33.76l7-4m1.41-3a.59.59,0,0,0-.29.07l-9.55,5.52c-.18.1-.57.28-.57.51V45.14a4,4,0,0,1,0,.51l-10.7,6.17a.6.6,0,0,0-.29.51v11a.59.59,0,0,0,.59.59.6.6,0,0,0,.29-.08l20.83-12a.6.6,0,0,0,.29-.51V27.27a.58.58,0,0,0-.59-.58Z"/>
          <path className="cls-2" 
            d="M35.92,64.94a1.58,1.58,0,0,1-.79-.21l-20.84-12a1.58,1.58,0,0,1-.79-1.37V24.87a1.58,1.58,0,0,1,.79-1.37L37.21,10.27a1.56,1.56,0,0,1,1.59,0l20.83,12a1.59,1.59,0,0,1,.79,1.37,1.61,1.61,0,0,1-.79,1.38L37.5,37.82V63.36a1.56,1.56,0,0,1-.79,1.37A1.58,1.58,0,0,1,35.92,64.94ZM15.5,51.09l20,11.54V37.58a1.6,1.6,0,0,1,.79-1.38L58,23.68,38,12.13l-22.49,13ZM37.79,12h0Zm.42,0Z"/>
        </g>
      </g>
    </SvgIcon>
  );
}
